import React from "react";
import "./WelcomeSection.css";
import ImageTest from "../../assets/img/welcome-screen/f&f1.png";

interface WelcomeSectionProps {
  onLoad?: () => void;
}
export const WelcomeSection: React.FC<WelcomeSectionProps> = ({ onLoad }) => {
  return (
    <section className="welcome-section">
      <div className="initials-image">
        <img
          src={ImageTest}
          alt="Iniciales F & F"
          loading="eager"
          onLoad={onLoad}
          className="blink-image"
          style={{ width: 200, height: 200 }}
        />
      </div>
    </section>
  );
};
